'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 *  Extracts entity links from a Rich Text document.
 */
function getRichTextEntityLinks(
/**
 *  An instance of a Rich Text Document.
 */
document, 
/**
 *  Node type. Only the entity links with given node type will be extracted.
 */
type) {
    var entityLinks = {
        Entry: new Map(),
        Asset: new Map(),
    };
    var content = (document && document.content) || [];
    for (var _i = 0, content_1 = content; _i < content_1.length; _i++) {
        var node = content_1[_i];
        addLinksFromRichTextNode(node, entityLinks, type);
    }
    return {
        Entry: iteratorToArray(entityLinks.Entry.values()),
        Asset: iteratorToArray(entityLinks.Asset.values()),
    };
}
function addLinksFromRichTextNode(node, links, type) {
    var toCrawl = [node];
    while (toCrawl.length > 0) {
        var _a = toCrawl.pop(), data = _a.data, content = _a.content, nodeType = _a.nodeType;
        var hasRequestedNodeType = !type || nodeType === type;
        if (hasRequestedNodeType && isLinkObject(data)) {
            links[data.target.sys.linkType].set(data.target.sys.id, data.target.sys);
        }
        if (Array.isArray(content)) {
            for (var _i = 0, content_2 = content; _i < content_2.length; _i++) {
                var childNode = content_2[_i];
                toCrawl.push(childNode);
            }
        }
    }
}
function isLinkObject(data) {
    var sys = data && data.target && data.target.sys;
    if (!sys) {
        return false;
    }
    var isValidLinkObject = typeof sys.id === 'string' && sys.type === 'Link';
    if (!isValidLinkObject) {
        return false;
    }
    var isEntityLink = sys.linkType === 'Entry' || sys.linkType === 'Asset';
    return isEntityLink;
}
/**
 * Used to convert the EntityLink iterators stored by the EntityLinkMap values
 * into a client-friendly array form.
 *
 * Alternately we could do:
 * 1) Array.from(EntityLinkMap)
 * 2) [...EntityLinkMap]
 *
 * #1, although idiomatic, is about half as slow as #2.
 *
 * #2, while faster than #1, requires transpilation of the iterator protocol[1],
 * which in turn is still only about half as fast as the approach below.
 *
 * [1] See https://blog.mariusschulz.com/2017/06/30/typescript-2-3-downlevel-iteration-for-es3-es5.
 */
function iteratorToArray(iterator) {
    var result = [];
    while (true) {
        var _a = iterator.next(), value = _a.value, done = _a.done;
        if (done) {
            break;
        }
        result.push(value);
    }
    return result;
}

exports.getRichTextEntityLinks = getRichTextEntityLinks;
//# sourceMappingURL=rich-text-links.es5.js.map
